import LoginContainer from '../../../containers/Login';
import AuthLayout from '../../../components/AuthLayout';

export default function Login() {
  return (
    <AuthLayout maxWidth="xl" title="رابکس | ورود">
      <LoginContainer />
    </AuthLayout>
  );
}
